export enum SupplierDocumentStatus {
  FORMAL_CONTROL = 'formal_control',
  FORMAL_CONTROL_FAILED = 'formal_control_failed',
  CONTENT_CONTROL = 'content_control',
  CONTENT_CONTROL_FAILED = 'content_control_failed',
  TIMED_OUT = 'timed_out',
  RECORD_LIBRARY_TRANSFER = 'record_library_transfer',
  RECORD_LIBRARY_TRANSFER_FAILED = 'record_library_transfer_failed',
  COMPLETED = 'completed',
}
